import { lazyLoad } from 'site-modules/shared/components/lazy-load/lazy-load';
import { LoadingDotsDrawer } from 'site-modules/shared/components/loading-dots/loading-dots-drawer';

export const UsurpFiltersDrawerContentAsync = lazyLoad({
  loader: () => import(/* webpackChunkName: "usurp-filters-drawer-content" */ './usurp-filters-drawer-content'),
  componentName: 'UsurpFiltersDrawerContent',
  loading: LoadingDotsDrawer,
});
